<template>
  <div>
    <PageTitle
    :main="$t('cadastro-de-produtos')"
    sub=""
    imagem="dashboard.png"
    />
    <GridProducts></GridProducts>
  </div>
</template>

<script>
import PageTitle from '../template/PageTitle.vue';
import GridProducts from './GridProducts.vue';

export default {
  name:"Product",
  components: { GridProducts, PageTitle }
}
</script>

<style scoped>

</style>